import { PaymentProvider } from '../components/services/AuthServiceTypes';

export enum AngularEvents {
  PaymentProviderLoaded = 'angular.payment.provider.loaded',
}

declare global {
  interface WindowEventMap {
    [AngularEvents.PaymentProviderLoaded]: CustomEvent<PaymentProvider | undefined>;
  }
}

type EventName = keyof WindowEventMap & `angular.${string}`;

export const dispatchAngularEvent = <K extends EventName>(
  type: K,
  detail: WindowEventMap[K]['detail'],
) => {
  window.dispatchEvent(new CustomEvent(type, { detail }));
};
